export class onInitGraph {
    action: string;
    value: boolean;
    change: boolean;
    constructor (action,value,change) {
        this.action =  action;
        this.value =  value;
        this.change =  change;
    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/broadcaster/app/onInit-graph.ts